import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import {
  GOLDEN_RATIO_PERCENTAGE,
  ONE_MINUS_GOLDEN_RATIO_PERCENTAGE,
  ONE_MINUS_THIRD_PERCENTAGE,
  THIRD_PERCENTAGE,
} from '../../utils/style-const';

export const FLOAT_LEFT = 'left';
export const FLOAT_CENTER = 'center';
export const FLOAT_RIGHT = 'right';

export const SIZE_THIRD = 'third'; // 33%
export const SIZE_GOLDEN_RATIO_INVERTED = 'goldenRatioInverted'; // 38%
export const SIZE_HALF = 'half'; // 50%
export const SIZE_GOLDEN_RATIO = 'goldenRatio'; // 62%
export const SIZE_THIRD_INVERTED = 'thirdInverted'; // 67%
export const SIZE_FULL = 'full'; // 100%
export const SIZE_AUTO = 'auto'; // 100%

const getStyles = ({ float, size }) => ({
  root: {
    textAlign: 'center',
    '@media (max-width: 600px)': {
      width: 'unset !important',
      margin: 'unset !important',
    },
  },
  [FLOAT_LEFT]: {
    margin: '0 auto 0 0',
  },
  [FLOAT_CENTER]: {
    margin: '0 auto 0 auto',
  },
  [FLOAT_RIGHT]: {
    margin: '0 0 0 auto',
  },
  [SIZE_THIRD]: {
    width: THIRD_PERCENTAGE,
  },
  [SIZE_GOLDEN_RATIO_INVERTED]: {
    width: ONE_MINUS_GOLDEN_RATIO_PERCENTAGE,
  },
  [SIZE_HALF]: {
    width: '50%',
  },
  [SIZE_GOLDEN_RATIO]: {
    width: GOLDEN_RATIO_PERCENTAGE,
    maxWidth: 1024,
  },
  [SIZE_THIRD_INVERTED]: {
    width: ONE_MINUS_THIRD_PERCENTAGE,
  },
  [SIZE_AUTO]: {
    width: 'auto',
    margin: '4px !important',
  },
});

const CommonContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'float' && prop !== 'size' })(({ theme, float, size }) => getStyles({ float, size }));

const CommonContainerComponent = ({ className, float, size, component: Component = 'div', ...rest }) => {
  return (
    <CommonContainer
      as={Component}
      className={`${float} ${size} root ${className}`}
      float={float}
      size={size}
      {...rest}
    />
  );
};

CommonContainerComponent.propTypes = {
  className: PropTypes.string,
  float: PropTypes.oneOf([
    FLOAT_LEFT,
    FLOAT_CENTER,
    FLOAT_RIGHT,
  ]),
  size: PropTypes.oneOf([
    SIZE_THIRD,
    SIZE_GOLDEN_RATIO_INVERTED,
    SIZE_HALF,
    SIZE_GOLDEN_RATIO,
    SIZE_THIRD_INVERTED,
    SIZE_FULL,
    SIZE_AUTO,
  ]),
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
};

CommonContainerComponent.defaultProps = {
  float: FLOAT_CENTER,
  size: SIZE_FULL,
  component: 'div',
};

export default CommonContainerComponent;
